import { functions } from "../firebase";

export type CampaignSummary = {
  id: string;
  subject: string;
  status: string;
  recipients: number | null;
  source: string | null;
  createdAt: string | null;
  sentAt: string | null;
  sentCount: number | null;
  openCount: number | null;
  clickCount: number | null;
};

export const listEmailCampaigns = async (
  communityId: string
): Promise<{ campaigns: CampaignSummary[] }> => {
  const callable = functions.httpsCallable("listEmailCampaigns");
  const result = await callable({ communityId });
  return result.data as { campaigns: CampaignSummary[] };
};

export const deleteEmailCampaign = async (
  communityId: string,
  campaignId: string
): Promise<{ deleted: boolean; campaignId: string }> => {
  const callable = functions.httpsCallable("deleteEmailCampaign");
  const result = await callable({ communityId, campaignId });
  return result.data as { deleted: boolean; campaignId: string };
};
